module.exports = __webpack_public_path__ + "images/category_lp/car/store_images/1_7a9e4b43af5b8ff749508ef8c3e3b50b.png";